<script>

  import { Pie } from 'vue-chartjs'
  import axios from 'axios'
  import Utils from '@/utils.js'
  import { EventBus } from '@/global-event-bus.js'
  import { EVENT_ANALYTIC_DATE_RANGE, DATE_FROM, DATE_TO } from '@/event-constants.js'

  export default {
    name: 'PieChart',

    extends: Pie,

    data() {
      return {
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                var value = data.datasets[0].data[tooltipItem.index]

                var total = data.datasets[0].data.reduce((val1, val2) => {
                  return val1 + val2
                })

                var percentage = ((value * 100.0) / total).toFixed(2)

                var label = data.labels[tooltipItem.index]

                if (label) {
                  label += ': ' + value + ' [ ' + percentage + '% ]'
                }

                return label
              }
            }
          }
        }
      }
    },

    props: {
      chartdata: {
        type: Object,
        default: null
      }
    },

    mounted() {
      this.renderChart(this.chartdata, this.options)
    },

    created() {
      EventBus.$on(EVENT_ANALYTIC_DATE_RANGE, this.fetchData)
    },

    beforeDestroy() {
      EventBus.$off(EVENT_ANALYTIC_DATE_RANGE, this.fetchData)
    },

    methods: {},

    computed: {},

    watch: {
      chartdata() {
        this.renderChart(this.chartdata, this.options)
      }
    }
  }

</script>

<style scoped></style>
